import React from 'react';
import _size from 'lodash/size';
import _isArray from 'lodash/isArray';

import { UiKit } from 'components';

export default function TableCellColumn({ children = null }) {
  const totalChildren = _isArray(children) ? _size(children) : 1;

  const gridColumns = Array.from({ length: totalChildren }, (_, index) => {
    const isLast = index === totalChildren - 1;
    return isLast ? '1fr' : 'auto';
  }).join(' ');

  return (
    <UiKit.Grid templateColumns={gridColumns} gap="4">
      {children}
    </UiKit.Grid>
  );
}
